/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {createContext} from 'react';
import {Theme} from '@asgardeo/browser';

export interface ThemeContextValue {
  theme: Theme;
  colorScheme: 'light' | 'dark';
  /**
   * The text direction for the UI.
   */
  direction: 'ltr' | 'rtl';
  toggleTheme: () => void;
  /**
   * Whether branding theme is currently loading
   */
  isBrandingLoading?: boolean;
  /**
   * Error from branding theme fetch, if any
   */
  brandingError?: Error | null;
  /**
   * Whether branding inheritance is enabled
   */
  inheritFromBranding?: boolean;
}

const ThemeContext = createContext<ThemeContextValue | null>(null);

ThemeContext.displayName = 'ThemeContext';

export default ThemeContext;
